import Immutable from 'immutable';

const LOAD = 'account/LOAD';
const LOAD_SUCCESS = 'account/LOAD_SUCCESS';
const LOAD_FAIL = 'account/LOAD_FAIL';

const SAVE_ACCOUNT = 'account/SAVE_ACCOUNT';
const SAVE_ACCOUNT_SUCCESS = 'account/SAVE_ACCOUNT_SUCCESS';
const SAVE_ACCOUNT_FAIL = 'account/SAVE_ACCOUNT_FAIL';

const SELECT_USER = 'account/SELECT_USER';

const RESET_MESSAGE = 'account/RESET_MESSAGE';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  loading: false,
  accountUsers: [],
  selectedUser: undefined
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('accountUsers', action.items)

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('accountUsers', null);

    case SAVE_ACCOUNT:
      return state
        .set('savingAccount', true)
        .set('saveAccountSuccess', null)
        .set('saveAccountErr', null);

    case SAVE_ACCOUNT_SUCCESS: {
      if (action.users) {
        return state
        .set('savingAccount', false)
        .set('saveAccountSuccess', action.message)
        .set('saveAccountErr', null)
        .set('accountUsers', action.users)
      }
      return state
        .set('savingAccount', false)
        .set('saveAccountSuccess', action.message)
        .set('saveAccountErr', null)
    }

    case SAVE_ACCOUNT_FAIL:
      return state
        .set('savingAccount', false)
        .set('saveAccountSuccess', false)
        .set('saveAccountErr', action.error);

    case RESET_MESSAGE:
      return state
        .set('savingAccount', false)
        .set('saveAccountSuccess', null)
        .set('saveAccountErr', null);

    case SELECT_USER:
      return state
        .set('selectedUser', action.user)

    default:
      return state;
  }
}


export const loadAccounts = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/account/all');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, error: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, items: res.rows, count: res.count });
    return res.rows;
  } catch (error) {
    let errorMessage = error.message;
    dispatch({ type: LOAD_FAIL, error: errorMessage });
  }
};

export const saveAccount = (accountDetails) => async (dispatch, getState, api) => {
  dispatch({ type: SAVE_ACCOUNT });
  try {
    if (accountDetails.id) {
      const users = getState().get('account').get('accountUsers');
      const index = users.findIndex((user) => user.id === accountDetails.id)
      if (accountDetails.isDeleted) {
        users.splice(index, 1);
      } else {
        let selectedUser = users[index];
        selectedUser.firstName = accountDetails.name;
        selectedUser.lastName =accountDetails.name;
        selectedUser.username = accountDetails.username;
        selectedUser.password = accountDetails.password
        users.splice(index, 1, selectedUser)
      }
      await api.put('/account', { data: accountDetails });
      dispatch(loadAccounts());
      dispatch({ type: SAVE_ACCOUNT_SUCCESS, message: "Updated Successfully", users });
    } else {
      await api.post('/account', { data: accountDetails });
      dispatch(loadAccounts());
      dispatch({ type: SAVE_ACCOUNT_SUCCESS, message: "Created Successfully" });
    }
   return accountDetails;
  } catch (err) {
    dispatch({ type: SAVE_ACCOUNT_FAIL, error: err.message });
    return err;
  }
};


export const selectUser = (user) => async (dispatch) => {
  dispatch( { type: SELECT_USER, user });
}



// WEBPACK FOOTER //
// ./src/redux/modules/account.js